import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 20px;
  & div[class*='LoadingContainer'] {
    height: fit-content;
    width: unset;
  }
`;
